import React, { type ReactNode } from "react";
import { ChatInterfaceSkeleton } from "@/components/skeletons/ChatInterfaceSkeleton";
import { useUser } from "@/providers/use-user";
import { useStreamSession } from "./useStreamSession";
import { StreamContext } from "./context";

/**
 * StreamProvider component.
 * Single responsibility: Provide stream context and manage initial loading display.
 *
 * @param children - Child components that will have access to stream context
 */
export const StreamProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // Get user loading state
  const { isLoading: userLoading } = useUser();

  // Orchestrate all streaming session logic
  const contextValue = useStreamSession();

  // Show loading indicator during initial load
  if (userLoading) {
    return (
      <StreamContext.Provider value={contextValue}>
        <ChatInterfaceSkeleton />
      </StreamContext.Provider>
    );
  }

  return (
    <StreamContext.Provider value={contextValue}>
      {children}
    </StreamContext.Provider>
  );
};
